
const settings = {
    'pro' : {
        'REACT_APP_EPMP_BASE_URL': 'https://api.multimedia.europarl.europa.eu/o/epmp-frontend-rest/v1.0',
        'REACT_APP_BASE_URL' : 'https://mp-cms-backend.ep-lavinia.eu/o/epmp-cms-rest/v1.0',
        'REACT_APP_INGEST_BASE_URL' : 'https://mp-cms-backend.ep-lavinia.eu/o/epmp-ingest-rest/v1.0',
        'PREVIEW': 'https://multimedia.europarl.europa.eu/en/',
        'URL_PREFIX' :'',
        'ibmS3TempBucket' : 'cos-es-mp-temporal-prod',
        'ibmS3Bucket' : 'cos-ep-mp-multimedia-prod',
        'S3_ENDPOINT' : 'cos-ep-mp-multimedia-prod.s3.eu-de.cloud-object-storage.appdomain.cloud',
        'old_cms_url' : 'https://mp-cms.ep-lavinia.eu'
    },
    'pre' : {
        'REACT_APP_EPMP_BASE_URL': 'https://mp-api-test.ep-lavinia.eu/o/epmp-frontend-rest/v1.0',
        'REACT_APP_BASE_URL' : 'https://mp-cms-backend-test.ep-lavinia.eu/o/epmp-cms-rest/v1.0',
        'REACT_APP_INGEST_BASE_URL' : 'https://mp-cms-backend-test.ep-lavinia.eu/o/epmp-ingest-rest/v1.0',
        'PREVIEW': 'https://multimediapp.europarl.europa.eu/en/',
        'URL_PREFIX' :'',
        'ibmS3TempBucket' : 'cos-es-mp-temporal-test',
        'ibmS3Bucket' : 'cos-ep-mp-multimedia-test',
        'S3_ENDPOINT' : 'cos-ep-mp-multimedia-test.s3.eu-de.cloud-object-storage.appdomain.cloud',
        'old_cms_url' : 'https://cms.multimediapp.europarl.europa.eu'
    },
    'local': {
        'REACT_APP_EPMP_BASE_URL': 'https://mp-api-test.ep-lavinia.eu/o/epmp-frontend-rest/v1.0',
        'REACT_APP_BASE_URL' : 'https://mp-cms-backend-test.ep-lavinia.eu/o/epmp-cms-rest/v1.0',
        'REACT_APP_INGEST_BASE_URL' : 'https://mp-cms-backend-test.ep-lavinia.eu/o/epmp-ingest-rest/v1.0',
        'PREVIEW': 'https://multimediapp.europarl.europa.eu/en/',
        'URL_PREFIX' :'',
        'ibmS3TempBucket' : 'cos-es-mp-temporal-test',
        'ibmS3Bucket' : 'cos-ep-mp-multimedia-test',
        'S3_ENDPOINT' : 'cos-ep-mp-multimedia-test.s3.eu-de.cloud-object-storage.appdomain.cloud',
        'old_cms_url' : 'https://cms.multimediapp.europarl.europa.eu'
    }
};



export function getEnvironment() {
    const host = window.location.host;
    const patterns = {
        'multimediapp' : 'pre',
        '-test' : 'pre',
        'localhost' : 'local'
    };

    for(let i in patterns){
        if(host.indexOf(i) !== -1) return patterns[i];
    }

    return 'pro';
}

export function getSetting(name){
    let env = getEnvironment();
    return (typeof settings[env][name] !== 'undefined')? settings[env][name]  : null;
}

export function getPreview(type, id) {
    let env = getEnvironment();

    if(type === 'streaming') type = 'webstreaming';
    if(type === 'tag' || type === 'person') {
        return (typeof settings[env]['PREVIEW'] !== 'undefined') ? `${settings[env]['PREVIEW']}${type}/${id}`  : null; 
    }

    return (typeof settings[env]['PREVIEW'] !== 'undefined')? `${settings[env]['PREVIEW']}${type}/cms_${id}`  : null;
}

export function getS3Endpoint(file) {
    const env = getEnvironment();
    return 'https://' + settings[env]['S3_ENDPOINT'] + '/' + file;
}

export function getMediaTypePreview(mediaType, id) {
    const env = getEnvironment();
    const mediaTypes = {
        'EPV_AUDIO': 'audio',
        'EPV_VIDEO_FOOTAGE': 'video',
        'EPV_EDITED_VIDEOS': 'video',
        'EPV_PHOTO': 'photo',
        'EPV_PHOTOSET': 'photoset',
        'EPV_AUDIO_PODCASTS': 'podcast',
        'EPV_INFOGRAPHICS': 'infographic',
        'WS_VIDEO': 'webstreaming'
    };

    return (typeof settings[env]['PREVIEW'] !== 'undefined')? `${settings[env]['PREVIEW']}${mediaTypes[mediaType]}/cms_${id}`  : null;
}

export function parseRelativeUrl(url){
    let urlPrefix = getSetting('URL_PREFIX');
    return urlPrefix + url;
}